import React, { Component } from "react"
import * as endpoints from "../../api/endpoints"
import ReactHtmlParser from "react-html-parser"
import { isMobile } from "react-device-detect"
import reactStringReplace from "react-string-replace"
import { DateTime } from "luxon"

export default class FlightInformationHero extends Component {
  constructor(props) {
    super(props)

    const modelJson = props.modelJson && JSON.parse(props.modelJson)

    this.state = {
      modelJson: modelJson,
      flights: [],
      direction: "D",
      language: (document.body && document.body.dataset.language) || "da",
      q: "",
      showResults: false,
      mouseOverResults: false,
    }
  }

  search = async () => {
    let flights = []
    if (this.state.q.length > 0) {
      const dt = DateTime.utc()
      const start = dt
      const end = dt.endOf("day")
      const data = { direction: this.state.direction, query: this.state.q, startDateTime: start, endDateTime: end, language: this.state.language }
      const response = await endpoints.getFlightInfoTable(data)
      if (response && response.data) {
        flights = response.data
      }
    }
    this.setState({ flights: flights })
  }

  handleInput = (event, search = true) => {
    this.setState(
      {
        [event.target.name]: event.target.value,
      },
      () => {
        if (search) this.search()
      },
    )
  }

  handleBlur = () => {
    // makes it possible to click the results without them disappearing
    if (!this.state.mouseOverResults) {
      this.setState({ showResults: false })
    }
  }

  handleFocus = () => {
    this.setState({ showResults: true })
  }

  stringReplace = (text, input) => {
    const words = input.split(" ").filter(Boolean)
    const regex = new RegExp("(" + words.join("*|") + ")", "gi")
    return reactStringReplace(text, regex, (match, i) => <strong key={match + i}>{match}</strong>)
  }

  render() {
    const heroType = this.props.backgroundVideo ? "hero--video" : "hero--image"
    const heroStyle = this.props.backgroundImage ? { backgroundImage: `url(${this.props.backgroundImage})` } : {}
    const inputStyle = this.state.flights.length > 0 ? { position: "relative", zIndex: "9401" } : {}
    const resultsStyle = isMobile ? { left: "1px", right: "1px" } : { width: "550px", left: "1px", top: "80px" }

    return (
      <section className="deck deck--top deck--front">
        <div className={`hero hero--search ${heroType}`}>
          <span className="hero__image" style={heroStyle}>
            <img src={this.props.backgroundImage ? this.props.backgroundImage : ""} loading="eager" fetchPriority="high" />
          </span>
          {this.props.backgroundVideo ? (
            <span className="hero__video">
              <video tabIndex={-1} playsInline muted autoPlay loop preload="auto" loading="eager" fetchPriority="high">
                <source src={this.props.backgroundVideo} type="video/mp4" />
              </video>
            </span>
          ) : (
            ""
          )}
          <div className="hero__content">
            <h6>{this.state.modelJson.label}</h6>
            {ReactHtmlParser(this.state.modelJson.heading)}
            <div className="form hero__search">
              <div className="form__section form__section--fat">
                <div className="hero__search__radios form__section__inner">
                  <div
                    className={`form__field form__field--radio form__field--radio--small is-bound ${
                      this.state.direction === "D" ? "is-checked" : ""
                    }`}
                  >
                    <label className="form__label">
                      <input
                        className="form__item "
                        name="direction"
                        type="radio"
                        value="D"
                        checked={this.state.direction === "D" ? "checked" : ""}
                        onChange={(e) => this.handleInput(e)}
                      />
                      <span className="form__label__text">
                        <p>{this.state.modelJson.departureLabel}</p>
                      </span>
                    </label>
                  </div>
                  <div
                    className={`form__field form__field--radio form__field--radio--small is-bound ${
                      this.state.direction === "A" ? "is-checked" : ""
                    }`}
                  >
                    <label className="form__label">
                      <input
                        className="form__item "
                        name="direction"
                        type="radio"
                        value="A"
                        checked={this.state.direction === "A" ? "checked" : ""}
                        onChange={(e) => this.handleInput(e)}
                      />
                      <span className="form__label__text">
                        <p>{this.state.modelJson.arrivalLabel}</p>
                      </span>
                    </label>
                  </div>
                </div>
                <div className="hero__search__text form__section__inner">
                  <div
                    className={`form__field form__field--text form__field--text--no-label is-bound ${
                      this.state.q.length > 0 && this.state.showResults ? "is-filled has-focus" : ""
                    }`}
                  >
                    <span className="form__valid"></span>
                    <input
                      autoComplete="off"
                      style={inputStyle}
                      className={`form__item ${this.state.flights.length > 0 && this.state.showResults ? "has-suggestions" : ""}`}
                      name="q"
                      type="text"
                      value={this.state.q}
                      onChange={(e) => this.handleInput(e)}
                      onBlur={() => this.handleBlur()}
                      onFocus={() => this.handleFocus()}
                      placeholder={this.state.modelJson.searchBoxPlaceholder}
                    />
                    {this.state.flights.length && this.state.q.length > 0 && this.state.showResults ? (
                      <div
                        className="search-ahead search-ahead--left is-visible is-active"
                        style={resultsStyle}
                        onMouseOver={() => this.setState({ mouseOverResults: true })}
                        onMouseOut={() => this.setState({ mouseOverResults: false })}
                      >
                        <div className="search-ahead__inner">
                          {this.state.flights.map((flight, index) => {
                            const destination = this.stringReplace(flight.DestinationName, this.state.q)
                            const airline = this.stringReplace(flight.Airline, this.state.q)
                            const iataDestination = this.stringReplace(flight.IataDestination, this.state.q)
                            if (index <= this.state.modelJson.numberOfFlights)
                              return (
                                <a
                                  key={index}
                                  href={`${this.state.direction === "A" ? this.state.modelJson.arrivalsPage : this.state.modelJson.departuresPage}/${
                                    flight.Iata
                                  }?id=${flight.FlightId}`}
                                >
                                  <div className="search-ahead__inner__item">
                                    <h5>
                                      {destination}
                                      <br />
                                      <small>{airline}</small>
                                    </h5>
                                    <h6>{iataDestination}</h6>
                                  </div>
                                </a>
                              )
                            else {
                              return
                            }
                          })}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <a
                    className="button button--general-inverted button--large"
                    href={`${this.state.direction === "A" ? this.state.modelJson.arrivalsPage : this.state.modelJson.departuresPage}?q=${
                      this.state.q
                    }`}
                  >
                    <span className="text">{this.state.modelJson.searchButtonLabel}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}
